module.exports = __webpack_public_path__ + "static/heatmap-1e46b5988a4dae92cdca4475ead01ce6.png";